// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+rIBv","photos":"styles_photos__CyUgC","photo":"styles_photo__XjRK6","last":"styles_last__3Otcy","img":"styles_img__95qgL"};